import React from 'react'
import NumberFormat from 'react-number-format'

export default function InputNumeroDecimal({
  value,
  onChange,
  label,
  decimalScale = 2,
  width = '100%',
  marginTop = 20,
  showLabel = true,
  disabled = false,
  placeholder = undefined,
}) {
  const styles = {
    container: {
      textAlign: 'left',
      marginTop,
    },
    label: {
      fontSize: '0.8rem',
      color: '#14B0BF',
      display: 'block',
    },
    input: {
      width,
      outline: 'none',
      border: '1px solid  #F1F1F1',
      height: 30,
      marginTop: 3,
      backgroundColor: disabled ? 'rgba(239, 239, 239, 0.3)' : 'rgba(255, 255, 255, 0.9)',
      padding: 10,
    },
  }

  return (
    <div style={styles.container}>
      {showLabel ? (
        <label style={styles.label} htmlFor="myInput">
          {label}
        </label>
      ) : null}
      <NumberFormat
        style={styles.input}
        thousandSeparator="."
        decimalSeparator=","
        decimalScale={decimalScale}
        fixedDecimalScale={true}
        isNumericString={true}
        value={value}
        onValueChange={({ value }) => onChange(value)}
        disabled={disabled}
        placeholder={placeholder}
      />
    </div>
  )
}
